import { ReactNode, useState } from "react"
import { createContext } from "react"
import { getUserId, getUsername, getUserSecret } from "./utils"

type Props = {
    children?: ReactNode
}

interface IAuthContext {
    authenticated : boolean,
    username : string | null,
    secret ?: string | null,
    id ?: string | null,
    setAuthenticated : (newState : boolean) => void
}
const initialValue : IAuthContext = {
    authenticated : false,
    username : getUsername(),
    secret : getUserSecret(),
    id : getUserId(),
    setAuthenticated : () => {}
}
const AuthContext = createContext<IAuthContext>(initialValue);

const AuthProvider = ({children}: Props) => {

    const [authenticated, setAuthenticated] = useState(initialValue.authenticated);

    const username = getUsername();

    const secret = getUserSecret();

    const id = getUserId();

    return (
        <AuthContext.Provider value={{authenticated, username, id, secret, setAuthenticated}}>
            {children}
        </AuthContext.Provider>
    )
}

export {AuthContext, AuthProvider}